export default {
    permissions: [],
}
